// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"76ee1bdb","116":"04dc592e","242":"9200b551","267":"cc9cace5","625":"67aab493","684":"ddc634f8","762":"63ce9617"}[chunkId] + ".chunk.js";
};